import { API } from "@/lib/api";
import { APIService, FetchListRequestParams } from "@/services/api";
import { ReadAuditLog } from "@/types/auditLog";

const service = new APIService<ReadAuditLog>(API.AuditLogs);

export const AuditLogsService = {
  getLogs: (params: FetchListRequestParams<ReadAuditLog>) =>
    service.getList(params),
};
